<template>
  <footer class="footer">
    <div class="footer-main container">
      <div class="footer-content">
        <!-- 左侧：Logo 和简介 -->
        <div class="footer-brand">
          <img class="footer-logo" src="../assets/image/logo.svg" alt="logo" />
          <p class="footer-desc">专注电子口岸卡智慧服务平台，为进出口企业提供一站式、全流程的专业服务解决方案。</p>
          <div class="footer-contact">
            <div class="contact-item">
              <span class="icon">📞</span>
              <span>{{ siteConfig.servicePhone }}</span>
            </div>
            <div class="contact-item">
              <span class="icon">✉️</span>
              <span>{{ siteConfig.serviceEmail }}</span>
            </div>
            <div class="contact-item">
              <span class="icon">🕐</span>
              <span>{{ siteConfig.workTime }}</span>
            </div>
          </div>
        </div>

        <!-- 右侧：链接列表 -->
        <div class="footer-links">
          <div class="link-column">
            <h4>制卡业务</h4>
            <ul>
              <li><a href="/product">企业新入网</a></li>
              <li><a href="/product">新增业务</a></li>
              <li><a href="/product">变更业务</a></li>
              <li><a href="/product">补办业务</a></li>
              <li><a href="/product">更新解锁</a></li>
              <li><a href="/product">安全产品</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h4>进出口权</h4>
            <ul>
              <li><a href="#">企业进出口权办理</a></li>
              <li><a href="#">海外商标注册办理</a></li>
              <li><a href="#">助力外贸出口退税</a></li>
              <li><a href="#">企业代理报关服务</a></li>
            </ul>
          </div>
          <div class="link-column">
            <h4>帮助支持</h4>
            <ul>
              <li><a href="/material">材料下载</a></li>
              <li><a href="/faq">常见问题</a></li>
              <li><a href="/news">政策资讯</a></li>
              <li><a href="#">联系我们</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权 -->
    <div class="footer-bottom">
      <div class="footer-bottom-inner container">
        <span class="footer-bottom-left">
          <template v-if="siteConfig.copyright">{{ siteConfig.copyright }}</template>
          <template v-if="siteConfig.copyright && siteConfig.icpNumber"> · </template>
          <a
            v-if="siteConfig.icpNumber"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            class="icp-link"
          >
            {{ siteConfig.icpNumber }}
          </a>
        </span>
        <div class="footer-bottom-links">
          <a href="javascript:;" @click.prevent="openPolicy('privacy')">隐私政策</a>
          <a href="javascript:;" @click.prevent="openPolicy('terms')">用户协议</a>
        </div>
      </div>
    </div>

    <PolicyPreviewModal ref="policyModalRef" />
  </footer>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { message } from "ant-design-vue";
import PolicyPreviewModal from "./PolicyPreviewModal.vue";
import { getPolicyFile } from "@/constants/policy";

const store = useStore();
const siteConfig = computed(() => store.getters.getSiteConfig);
const policyModalRef = ref(null);

function openPolicy(type) {
  const policy = getPolicyFile(type, siteConfig.value);
  if (!policy?.url) {
    message.warning("暂未配置政策文件");
    return;
  }
  policyModalRef.value?.open({
    title: policy.title,
    url: policy.url,
  });
}
</script>

<style lang="scss" scoped>
.footer {
  background: #1a3a6b;
  color: rgba(255, 255, 255, 0.7);
  padding: 40px 0 0;

  p, span, a, div {
    color: rgba(255, 255, 255, 0.7);
  }
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 48px;
}

.footer-brand {
  .footer-logo {
    height: 36px;
    filter: brightness(0) invert(1);
    opacity: 0.9;
    margin-bottom: 16px;
  }

  .footer-desc {
    font-size: 13px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 20px;
  }
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .contact-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.7);

    .icon {
      font-size: 14px;
    }
  }
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.link-column {
  h4 {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;

    li a {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.7);
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: #f07800;
      }
    }
  }
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 24px;
}

.footer-bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 11px 0;
  max-width: 1100px;
  margin: 0 auto;
}

.footer-bottom-left {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.28);

  .icp-link {
    color: rgba(255, 255, 255, 0.28);
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  a {
    color: rgba(255, 255, 255, 0.28);
    text-decoration: none;
    font-size: 12px;
    margin-left: 11px;
    transition: color 0.2s;
    cursor: pointer;

    &:hover {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .footer-links {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-bottom-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 0 16px;
  }

  .footer-bottom-links {
    a:first-child {
      margin-left: 0;
    }
  }
}
</style>
